export default __webpack_public_path__ + "static/p2-72abda474d968aaa93348490f117a249.png";